import { sizeTab, texto, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TiketsUsuariosAprobadosPagina from "./tikets-usuarios-aprobadas/TiketsUsuariosAprobadasPage";
import TiketsUsuariosEnesperasPagina from "./tikets-usuarios-en-espera/TiketsUsuariosEnesperaPage";
import TiketsUsuariosRechazadosPagina from "./tikets-usuarios-rechazadas/TiketsUsuariosRechazadasPage";

export default function VerTiketsUsuariosPagina() {

  const [valueTab, setValueTab] = useState(0);
  const returnUrl = '/tikets/usuarios-tikets/ver';

  return (

    <SingleTableBoxScene title={"Tickets de usuario"} urlRedirect={`${returnUrl}/crear`} >

      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.tickets_espera} {...a11yProps(0)} />
          <Tab label={texto.tickets_aprobadas} {...a11yProps(2)} />
          <Tab label={texto.tickets_rechazada} {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TiketsUsuariosEnesperasPagina />
      </CustomTabPanel>
      
      <CustomTabPanel value={valueTab} index={1}>
        <TiketsUsuariosAprobadosPagina />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={2}>
        <TiketsUsuariosRechazadosPagina />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );


}


